import http from "../../services/http-common";
import authHeader from "../../services/auth-header";

// Dashboard
const getDashboardStats = () => {
    return http.get("admin/dashboard", { headers: authHeader() });
};

const getKpiStats = () => {
    return http.get("admin/kpi-stats", { headers: authHeader() });
};

const getUserStats = () => {
    return http.get("admin/users/stats", { headers: authHeader() });
};

const getRecentPosts = () => {
    return http.get("admin/recentposts", { headers: authHeader() });
};

const getRecentUsers = () => {
    return http.get("admin/recent-users", { headers: authHeader() });
};

const getRecentSells = () => {
    return http.get("admin/recent-sells", { headers: authHeader() });
};

const getRecentSubscriptions = () => {
    return http.get("admin/recent-subscriptions", { headers: authHeader() });
};

// Users
const getUsers = (params) => {
    return http.get("api/admin/users", { headers: authHeader(), params });
};

const exportUsers = () => {
    return http.get("api/admin/users/export", { headers: authHeader(), responseType: "blob" });
};

// Countries
const getCountries = () => {
    return http.get("api/location/mycountrylist", { headers: authHeader() });
};

const addCountry = (data) => {
    return http.post("api/location/mycountrylist/save", data, { headers: authHeader() });
};

const updateCountry = (data) => {
    return http.put("api/location/update", data, { headers: authHeader() });
};

const deleteCountry = (id) => {
    return http.delete(`api/location/${id}`, { headers: authHeader() });
};

const getUserById = (id) => {
    return http.get(`admin/users/${id}`, { headers: authHeader() });
};

const blockUser = (id, remark) => {
    return http.put(`api/admin/users/block/${id}?remark=${encodeURIComponent(remark || "")}`, {}, { headers: authHeader() });
};

const unblockUser = (id, remark) => {
    return http.put(`api/admin/users/unblock/${id}?remark=${encodeURIComponent(remark || "")}`, {}, { headers: authHeader() });
};

const updateUser = (data) => {
    return http.post("user/update", data, { headers: authHeader() });
};

const creditWallet = (data) => {
    return http.post("admin/users/wallet/credit", data, { headers: authHeader() });
};

const debitWallet = (data) => {
    return http.post("admin/users/wallet/debit", data, { headers: authHeader() });
};

const getUserTransactions = (userId) => {
    return http.get(`admin/users/${userId}/transactions`, { headers: authHeader() });
};

// Ads / Products
const getAds = (params) => {
    return http.get("api/admin/ads", { headers: authHeader(), params });
};

const getRejectedAds = (params) => {
    return http.get("api/admin/ads/rejected", { headers: authHeader(), params });
};

const acceptAd = (id, comment) => {
    return http.patch(`api/admin/ads/${id}/accept`, { comment }, { headers: authHeader() });
};

const rejectAd = (id, comment) => {
    return http.patch(`api/admin/ads/${id}/reject`, { comment }, { headers: authHeader() });
};

const deleteAd = (id) => {
    return http.delete(`admin/ads/${id}`, { headers: authHeader() });
};

const featureAd = (id) => {
    return http.post(`admin/ads/${id}/feature`, {}, { headers: authHeader() });
};

const unfeatureAd = (id) => {
    return http.post(`admin/ads/${id}/unfeature`, {}, { headers: authHeader() });
};

const getReportedAds = () => {
    return http.get("admin/ads/reported", { headers: authHeader() });
};

const getAdById = (id) => {
    return http.get(`api/admin/ads/${id}`, { headers: authHeader() });
};

const createAd = (data) => {
    return http.post("admin/ads", data, { headers: authHeader() });
};

const updateAd = (id, data) => {
    return http.put(`admin/ads/${id}`, data, { headers: authHeader() });
};


const extendAdExpiry = (id, days) => {
    return http.post(`admin/ads/${id}/extend`, { days }, { headers: authHeader() });
};

const bulkAdAction = (action, ids) => {
    return http.post("admin/ads/bulk", { action, ids }, { headers: authHeader() });
};

// Subscriptions
const getSubscriptions = (params) => {
    return http.get("admin/subscriptions", { headers: authHeader(), params });
};

const updatePlan = (data) => {
    return http.post("admin/subscriptions/plan", data, { headers: authHeader() });
};

const extendSubscription = (id, days) => {
    return http.post(`admin/subscriptions/${id}/extend`, { days }, { headers: authHeader() });
};

const terminateSubscription = (id) => {
    return http.post(`admin/subscriptions/${id}/terminate`, {}, { headers: authHeader() });
};

const getTopUpPackages = () => {
    return http.get("topUp/getall", { headers: authHeader() });
};

const updateTopUpPackage = (data) => {
    return http.put("topUp/update", data, { headers: authHeader() });
};

// Categories
const getCategories = () => {
    return http.get("category/subcategory", { headers: authHeader() });
};

const createCategory = (data) => {
    return http.post("category/categories/save", data, { headers: authHeader() });
};

const saveCategory = (data) => {
    return http.post("category/categories/save", data, { headers: authHeader() });
};

const updateCategory = (id, data) => {
    return http.put(`category/${id}`, data, { headers: authHeader() });
};

const deleteCategory = (id) => {
    return http.delete(`category/${id}`, { headers: authHeader() });
};

const createSubCategory = (categoryId, data) => {
    return http.post("category/categories/save", { ...data, parentCategoryId: categoryId }, { headers: authHeader() });
};

const deleteSubCategory = (categoryId, subId) => {
    return http.delete(`category/${subId}`, { headers: authHeader() });
};

// Support
const getSupportTickets = () => {
    return http.get("helpsupport/contactus/getall", { headers: authHeader() });
};

const replyToTicket = (id, message) => {
    return http.post(`helpsupport/contactus/${id}/reply`, { message }, { headers: authHeader() });
};

const updateTicketStatus = (id, status) => {
    return http.put(`helpsupport/contactus/${id}/status?status=${status}`, null, { headers: authHeader() });
};

const updateTicketTag = (id, tag) => {
    return http.post(`helpsupport/contactus/${id}/tag`, { tag }, { headers: authHeader() }); // Still keep tag if used, but status is now primary
};

const sendAnnouncement = (data) => {
    return http.post("Notification/send/targeted/notification", data, { headers: authHeader() });
};

// Moderation
const getCommentsByPost = () => {
    return http.get("admin/moderation/comments/post", { headers: authHeader() });
};

const getCommentsByUser = () => {
    return http.get("admin/moderation/comments/user", { headers: authHeader() });
};

const blockComment = (id) => {
    return http.post(`admin/moderation/comments/${id}/block`, {}, { headers: authHeader() });
};

// System Settings
const getSystemSettings = () => {
    return http.get("admin/settings", { headers: authHeader() });
};

const updateGeneralSettings = (data) => {
    return http.post("admin/settings/general", data, { headers: authHeader() });
};

const updateSmtpSettings = (data) => {
    return http.post("admin/settings/smtp", data, { headers: authHeader() });
};

const updateSecuritySettings = (data) => {
    return http.post("admin/settings/security", data, { headers: authHeader() });
};

const testSmtp = (data) => {
    return http.post("admin/settings/smtp/test", data, { headers: authHeader() });
};

// Admin Profile
const getAdminProfile = () => {
    return http.get("admin/profile", { headers: authHeader() });
};

const updateAdminProfile = (data) => {
    return http.post("admin/profile", data, {
        headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
};

const changeAdminPassword = (data) => {
    return http.post("admin/profile/password", data, { headers: authHeader() });
};

const toggleTwoFactor = (data) => {
    return http.post("admin/profile/2fa", data, { headers: authHeader() });
};

const getAdmins = () => {
    return http.get("api/admin/activity-logs/admins", { headers: authHeader() });
};

const getActivityLogs = (data) => {
    return http.post("api/admin/activity-logs/search", data, { headers: authHeader() });
};

const exportActivityLogs = (params) => {
    return http.get("api/admin/activity-logs/export", { headers: authHeader(), params, responseType: "blob" });
};

const getUserSessions = (params) => {
    return http.get("api/admin/activity-logs/sessions", { headers: authHeader(), params });
};

// Location APIs
const getLocationCountries = () => {
    return http.get("api/location/mycountrylist", { headers: authHeader() });
};

const getStatesByCountryId = (countryId) => {
    return http.get(`api/location/state/country/${countryId}`, { headers: authHeader() });
};

const getStatesByCca2 = (cca2) => {
    return http.get(`api/location/state/${cca2}`, { headers: authHeader() });
};

const getCitiesByStateId = (stateId) => {
    return http.get(`api/location/city/${stateId}`, { headers: authHeader() });
};

// Analytics
const getUserRegistrations = (startDate, endDate) => {
    return http.get(`admin/stats/user-registrations?startDate=${startDate}&endDate=${endDate}`, { headers: authHeader() });
};

const getSubscriptionPurchases = (startDate, endDate) => {
    return http.get(`admin/stats/subscription-purchases?startDate=${startDate}&endDate=${endDate}`, { headers: authHeader() });
};

const getAdsPosted = (startDate, endDate) => {
    return http.get(`admin/stats/ads-posted?startDate=${startDate}&endDate=${endDate}`, { headers: authHeader() });
};

const getProductsSold = (startDate, endDate) => {
    return http.get(`admin/stats/products-sold?startDate=${startDate}&endDate=${endDate}`, { headers: authHeader() });
};

// Reports
const getReports = (params) => {
    return http.get("api/reports/report/getall", { headers: authHeader(), params });
};

const getPendingReports = () => {
    return http.get("api/reports/pending", { headers: authHeader() });
};

const takeReportAction = (reportId, action) => {
    return http.post(`api/reports/${reportId}/action?action=${action}`, {}, { headers: authHeader() });
};

const getReportDetails = (targetId, targetType) => {
    return http.get(`api/reports/details?targetId=${targetId}&targetType=${targetType}`, { headers: authHeader() });
};

const getUserProducts = (userId) => {
    return http.get(`api/reports/user-products/${userId}`, { headers: authHeader() });
};

const unblockProduct = (productId) => {
    return http.post(`api/reports/unblock/${productId}`, {}, { headers: authHeader() });
};

const permanentlyBlockProduct = (productId) => {
    return http.post(`api/reports/permanently-block/${productId}`, {}, { headers: authHeader() });
};

const moderatorBlockUser = (userId) => {
    return http.post(`api/reports/user/block/${userId}`, {}, { headers: authHeader() });
};

const moderatorUnblockUser = (userId) => {
    return http.post(`api/reports/user/unblock/${userId}`, {}, { headers: authHeader() });
};

const moderatorSendAlert = (userId) => {
    return http.post(`api/reports/user/alert/${userId}`, {}, { headers: authHeader() });
};

const moderatorPermanentlyBlock = (userId) => {
    return http.post(`api/reports/user/permanently-block/${userId}`, {}, { headers: authHeader() });
};

const AdminService = {
    getDashboardStats,
    getRecentPosts,
    getRecentUsers,
    getUsers,
    getUserById,
    updateUser,
    deleteUser: (id) => http.post(`admin/user/delete?userId=${id}`, {}, { headers: authHeader() }),
    blockUser,
    unblockUser,
    creditWallet,
    debitWallet,
    getUserTransactions,
    getAds,
    getRejectedAds,
    acceptAd,
    rejectAd,
    deleteAd,
    featureAd,
    unfeatureAd,
    getReportedAds,
    getAdById,
    createAd,
    updateAd,
    extendAdExpiry,
    bulkAdAction,
    getCountries,
    addCountry,
    updateCountry,
    deleteCountry,
    getSubscriptions,
    updatePlan,
    extendSubscription,
    terminateSubscription,
    getTopUpPackages,
    updateTopUpPackage,
    getCategories,
    createCategory,
    saveCategory,
    updateCategory,
    deleteCategory,
    createSubCategory,
    deleteSubCategory,
    // =============== Plans & Subscriptions ===============
    getPlans: () => http.get("subscription/getall", { headers: authHeader() }),
    createPlan: (data) => http.post("subscription/save", data, { headers: authHeader() }),
    updatePlanDetails: (data) => http.put("subscription/update", data, { headers: authHeader() }),
    deletePlan: (id) => http.delete(`subscription/delete/${id}`, { headers: authHeader() }),
    togglePlanStatus: (id, status) => http.put(`subscription/status/${id}?status=${status}`, null, { headers: authHeader() }),
    getUserSubscriptions: () => http.get("admin/recent-subscriptions", { headers: authHeader() }),
    // =====================================================
    getSupportTickets,
    replyToTicket,
    updateTicketStatus,
    updateTicketTag,
    sendAnnouncement,
    getCommentsByPost,
    getCommentsByUser,
    blockComment,
    getSystemSettings,
    updateGeneralSettings,
    updateSmtpSettings,
    updateSecuritySettings,
    testSmtp,
    getAdminProfile,
    updateAdminProfile,
    changeAdminPassword,
    toggleTwoFactor,
    getAdmins,
    getActivityLogs,
    exportActivityLogs,
    getRecentSells,
    getRecentSubscriptions,
    getKpiStats,
    getLocationCountries,
    getStatesByCountryId,
    getStatesByCca2,
    getCitiesByStateId,
    getUserStats,
    getUserRegistrations,
    getSubscriptionPurchases,
    getAdsPosted,
    getProductsSold,
    exportUsers,
    getReports,
    getPendingReports,
    takeReportAction,
    getReportDetails,
    getUserProducts,
    unblockProduct,
    permanentlyBlockProduct,
    moderatorBlockUser,
    moderatorUnblockUser,
    moderatorSendAlert,
    moderatorPermanentlyBlock,
    getUserSessions
};

export default AdminService;
